(ns practitest.frontend.components.searchable-list
  "Searchable async select component using react-select"
  (:require
   ["react-select/async" :default AsyncSelect]
   ["react-select" :refer [components]]
   [practitest.frontend.components.icons :as icons]
   [practitest.frontend.components2.spinners :as spinners]
   [reagent.core :as r]
   [goog.string :as gstring]
   [goog.string.format]))

(def async-select (r/adapt-react-class AsyncSelect))
(def default-page-size 100)

(defn full-width-select-styles
  "react-select :styles override forcing the container/control/menu to fill their parent width.
   For use with async-select directly - the searchable-async-select wrapper below doesn't honor
   a caller-supplied :styles prop. `provided` is a raw JS object (react-select's style-callback
   arg), not a cljs map - must merge with js/Object.assign, not clojure.core/merge."
  []
  #js {:container (fn [provided] (js/Object.assign #js {} provided #js {:width "100%"}))
       :control (fn [provided] (js/Object.assign #js {} provided #js {:width "100%"}))
       :menu (fn [provided] (js/Object.assign #js {} provided #js {:width "100%"}))})

(defn fetch-options
  [url input-value callback issue_type_id start-at page-size transform]
  (if (< (count input-value) 3) 
    (callback (transform {:users [], :has_more true}))
  (let [start-at (or start-at 0)          ;; default to 0 if nil
        page-size (or page-size default-page-size)   ;; default to 50 if nil
        encoded-term (js/encodeURIComponent input-value)
        request-url (gstring/format url encoded-term start-at page-size issue_type_id)]
    (-> (js/fetch request-url
                  (clj->js {:credentials "include"}))
        (.then #(.json %))
        (.then #(js->clj % :keywordize-keys true))
        (.then (fn [response]
                 (callback (transform response))))))))

(defn custom-drop-down [props]
  (let [focused (.-isFocused props)]
    (r/as-element
     [:div {:className (.-cx props) :style {:width "27px"}}
      (if focused
        [icons/mux-chevron-up2]
        [icons/mux-chevron-down2])])))

(defn custom-control [props]
  (let [DefaultControl (.-Control components)]
    (r/create-element "div" #js {:className "search-input" :style #js {:padding 0}}
                      (r/create-element DefaultControl props (.. props -children)))))

(defn custom-clear-indicator [props]
  (r/as-element [:div {:style {:width "27px"} :on-click (.-clearValue props)} [icons/mux-x]]))

(defn custom-loading-indicator [_props]
  (r/as-element [spinners/mux-spinner {:size :text :fade-in? true}]))

(def custom-components
  #js {:DropdownIndicator custom-drop-down :ClearIndicator custom-clear-indicator :Control custom-control
       :LoadingIndicator custom-loading-indicator})

(defn searchable-async-select
  "React-select based async searchable dropdown with infinite scroll"
  [{:keys [url
           page-size
           cache-options
           default-options
           is-clearable
           placeholder
           issue_type_id
           transform]
    :or {cache-options true
         default-options true
         is-clearable true
         placeholder "Search ..."}}]
  (let [start-at (r/atom 0)
        has-more? (r/atom true)
        custom-styles #js {:container (fn [provided]
                                        (js/Object.assign
                                         #js {}
                                         provided
                                         #js {:width "100%"
                                              :maxWidth "100%"}))
                           :control (fn [provided]
                                      (js/Object.assign
                                       #js {}
                                       provided
                                       #js {:width "100%"
                                            :maxWidth "100%"
                                            :boxShadow "none"
                                            :border "none"}))
                           :indicatorSeparator (fn [provided _] (js/Object.assign #js {} provided #js {:display "none"}))
                           :menu (fn [provided]
                                   (js/Object.assign
                                    #js {}
                                    provided
                                    #js {:width "100%"
                                         :maxWidth "100%"}))}
        handle-menu-scroll-to-bottom
        (fn []
          (when @has-more?
            (fetch-options url ""
                           (fn [options]
                             (when (empty? options)
                               (reset! has-more? false))
                             (swap! start-at + page-size))
                           issue_type_id
                           @start-at
                           page-size
                           transform)))]

    (fn [{:keys [value on-change aria-labelledby]}]
      [async-select
       {:aria-labelledby aria-labelledby
        :cacheOptions cache-options
        :defaultOptions default-options
        :value  value
        :className "g2-field-container"
        :loadOptions (fn [input-value callback]
                       (reset! start-at 0)
                       (fetch-options url input-value callback issue_type_id @start-at page-size transform))
        :onMenuScrollToBottom handle-menu-scroll-to-bottom
        :isClearable is-clearable
        :menuPlacement "auto"
        :menuPosition "fixed"
        :placeholder placeholder
        :styles custom-styles
        :components custom-components
        :onChange #(do 
                     (when on-change
                       (on-change (js->clj % :keywordize-keys true))))}])))